module.exports = __webpack_public_path__ + "img/Board_FB.ae901bc9.png";